import "./BPMFileInput.scss";
import { Button, ButtonType, ButtonProps } from "../Button/Button";
import React from "react";

interface FileInputProps extends Omit<ButtonProps, "type"> {
  buttonText?: string;
  id: string;
  name: string;
  onChange: any;
  type?: ButtonType;
}

export const BPMFileInput: React.FC<FileInputProps> = React.memo(
  ({
    // File Input Props
    buttonText = "Add File",
    className,
    id,
    name,
    onChange,

    // Button Props
    type = ButtonType.FILLED,
    variant,
    size,
    design,
    background,
    icon,
    disabled,
    enableAnimation,
    onClick,
    ...passthrough
  }) => {
    return (
      <div className={`BPMFileInput ${className}`}>
        <Button
          {...passthrough}
          type={type}
          className={`BPMFileInputInnerButton ${className}`}
          variant={variant}
          size={size}
          design={design}
          background={background}
          icon={icon}
          disabled={disabled}
          enableAnimation={enableAnimation}
          onClick={onClick}
        >
          <label htmlFor={id} className={"BPMFileInputInnerLabel"}>
            {`${buttonText}`}
          </label>
        </Button>
        <input
          className={`BPMFileInputInnerInputElement ${className}`}
          type="file"
          name={name}
          id={id}
          onChange={onChange}
        />
      </div>
    );
  }
);
